<template>
  <div>
    <vx-card>
      <ListConvenio :subjectPermission="subjectPermission"></ListConvenio>
    </vx-card>
  </div>
</template>

<script>
import ListConvenio from "./../../lists/ListConvenio";

export default {
  data() {
    return {
      subjectPermission: "Convênio",
    };
  },
  methods: {},
  components: {
    ListConvenio,
  },
};
</script>
